import { useEffect, useState } from "react";
import { Download, Film, Play } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

const CUTS = [
  ["square", "Square 1:1", "Facebook & Instagram feed"],
  ["vertical", "Vertical 9:16", "Reels, Stories, TikTok"],
  ["wide", "Widescreen 16:9", "Facebook video tab, YouTube"],
];

const mb = (bytes) => `${(bytes / 1e6).toFixed(1)} MB`;

/* A downloadable commercial: review it, then grab the cut you want to upload. */
export const CommercialCard = ({ film = "ad", route = "/ad", title = "The 30-second commercial",
  blurb = "Built for a paid or organic social post — separate from the welcome tour. Review it, then download and upload it to Facebook." }) => {
  const [cuts, setCuts] = useState(null);

  useEffect(() => {
    fetch(`${API}/api/public/${film}/manifest`)
      .then((r) => (r.ok ? r.json() : Promise.reject(r.status)))
      .then((d) => setCuts(d.cuts || {}))
      .catch(() => setCuts({}));
  }, [film]);

  const ready = cuts && Object.keys(cuts).length > 0;

  return (
    <section data-testid={`commercial-card-${film}`}
      className="rounded-lg border border-border bg-white overflow-hidden">
      <div className="flex items-start gap-3 px-5 py-4 border-b border-border">
        <Film className="h-4 w-4 text-gold mt-0.5 shrink-0" />
        <div>
          <h2 className="font-display text-base md:text-lg font-semibold text-royal-deep">{title}</h2>
          <p className="text-xs text-muted-foreground mt-0.5">{blurb}</p>
        </div>
      </div>
      <div className="p-5">
        <div className="flex flex-wrap gap-2.5">
          <a href={route} target="_blank" rel="noreferrer" data-testid={`commercial-preview-${film}`}
            className="inline-flex h-11 items-center gap-2 rounded-full bg-royal px-5 text-xs
                       font-bold uppercase tracking-[0.14em] text-white hover:bg-royal-deep
                       transition-colors duration-200">
            <Play className="h-3.5 w-3.5" /> Watch it
          </a>
          {CUTS.map(([key, label, use]) => {
            const info = cuts?.[key];
            return (
              <a key={key}
                href={info ? `${API}/api/public/${film}/${key}/download` : undefined}
                data-testid={`commercial-download-${film}-${key}`}
                aria-disabled={!info}
                className={`inline-flex h-11 items-center gap-2 rounded-full border px-5 text-xs
                            font-bold uppercase tracking-[0.14em] transition-colors duration-200
                            ${info ? "border-gold/60 text-royal-deep hover:bg-gold/10"
                                   : "border-border text-muted-foreground pointer-events-none opacity-60"}`}
                title={use}>
                <Download className="h-3.5 w-3.5" /> {label}
                {info && <span className="font-normal normal-case tracking-normal opacity-60">
                  {mb(info.bytes)}
                </span>}
              </a>
            );
          })}
        </div>
        <p className="mt-3.5 text-[11px] text-muted-foreground">
          {ready
            ? "Square is the safest choice for a Facebook feed post; vertical is for Reels and Stories. Facebook re-encodes every upload, so upload the original file rather than a screen recording."
            : "This commercial is still rendering — the download buttons light up as each cut finishes."}
        </p>
      </div>
    </section>
  );
};

export default CommercialCard;
